// Illustrative demo session for the landing page. Names, IDs and numbers are
// invented; none come from real logs. Values follow the backend's formulas:
// net = collected - invested (winloss.py), VPIP/PFR/3-bet % = hands with the
// action / hands played (script.py), transfers from Ledger.jsx's settleDebts.

export const SESSION = {
  title: 'Thursday game · 0.25/0.50',
  hands: 212,
  hero: 'You',
};

// Hand #87 as it appears in a PokerNow full log, then as parsed.
export const LOG_LINES = [
  { t: '21:14:02', text: '-- starting hand #87 (No Limit Texas Hold\'em) (dealer: "Priya @ Pr7Kd2") --', field: 'number' },
  { t: '21:14:02', text: '"Marisol @ Mx4qL9" posts a small blind of 0.25' },
  { t: '21:14:02', text: '"Theo @ Th2wN8" posts a big blind of 0.50' },
  { t: '21:14:03', text: 'Your hand is K♠, Q♠', field: 'hole' },
  { t: '21:14:09', text: '"You @ Yu9cR3" raises to 1.50', field: 'invested' },
  { t: '21:14:15', text: '"Theo @ Th2wN8" calls 1.50' },
  { t: '21:14:16', text: 'Flop:  [Q♦, 7♠, 2♠]', field: 'flop' },
  { t: '21:14:24', text: '"You @ Yu9cR3" bets 2.25', field: 'invested' },
  { t: '21:14:29', text: '"Theo @ Th2wN8" calls 2.25' },
  { t: '21:14:31', text: 'Turn: Q♦, 7♠, 2♠ [9♣]', field: 'turn' },
  { t: '21:14:36', text: '"You @ Yu9cR3" bets 5.00', field: 'invested' },
  { t: '21:14:38', text: '"Theo @ Th2wN8" calls 5.00' },
  { t: '21:14:40', text: 'River: Q♦, 7♠, 2♠, 9♣ [A♠]', field: 'river' },
  { t: '21:14:47', text: '"You @ Yu9cR3" bets 9.75', field: 'invested' },
  { t: '21:14:51', text: '"Theo @ Th2wN8" calls 9.75' },
  { t: '21:14:52', text: '"Theo @ Th2wN8" shows a J♠, T♦.', field: 'opponent' },
  { t: '21:14:53', text: '"You @ Yu9cR3" collected 37.25 from pot', field: 'collected' },
  { t: '21:14:53', text: '-- ending hand #87 --' },
];

export const PARSED_HAND = {
  number: 87,
  hole: ['K♠', 'Q♠'],
  flop: ['Q♦', '7♠', '2♠'],
  turn: '9♣',
  river: 'A♠',
  opponent: { name: 'Theo', cards: ['J♠', 'T♦'] },
  invested: 18.5,
  collected: 37.25,
  net: 18.75,
  pot: 37.25,
};

// Player metrics for the whole session.
export const PLAYERS = [
  { name: 'You', hands: 212, vpip: 24.1, pfr: 18.4, threeBet: 7.1, hero: true },
  { name: 'Priya', hands: 212, vpip: 19.8, pfr: 16.0, threeBet: 8.9 },
  { name: 'Jun', hands: 154, vpip: 55.2, pfr: 30.5, threeBet: 14.3 },
  { name: 'Marisol', hands: 207, vpip: 28.5, pfr: 21.3, threeBet: 6.2 },
  { name: 'Theo', hands: 198, vpip: 41.4, pfr: 12.6, threeBet: 3.5 },
  { name: 'Lena', hands: 189, vpip: 33.9, pfr: 8.5, threeBet: 1.6 },
  { name: 'Rafa', hands: 121, vpip: 46.3, pfr: 25.6, threeBet: 11.6 },
  { name: 'Dmitri', hands: 176, vpip: 14.2, pfr: 9.1, threeBet: 2.8 },
];

// What Jun showed down, grouped by preflop bet level like chart_raise / chart_3bet.
export const SHOWDOWNS = {
  player: 'Jun',
  levels: [
    {
      label: 'Raise',
      hands: [
        { hand: 12, cards: ['A♦', '4♦'], amount: 1.5 },
        { hand: 58, cards: ['K♥', 'J♣'], amount: 1.5 },
        { hand: 121, cards: ['9♠', '9♦'], amount: 1.75 },
        { hand: 176, cards: ['6♣', '5♣'], amount: 1.5 },
      ],
    },
    {
      label: '3-bet',
      hands: [
        { hand: 142, cards: ['Q♣', '7♥'], amount: 4.5 },
        { hand: 33, cards: ['A♠', '2♠'], amount: 4.5 },
        { hand: 97, cards: ['8♠', '6♠'], amount: 5.0 },
      ],
    },
    {
      label: '4-bet',
      hands: [{ hand: 164, cards: ['K♥', 'K♦'], amount: 12.0 }],
    },
  ],
};

// Your cumulative net through the session: [hand number, running net].
// #87 adds +18.75 and #142 loses -31.25, matching TOP_HANDS.
export const NET_SERIES = [
  [1, 0], [8, -1.5], [15, 2.25], [22, 1], [30, -3.75], [38, -2], [45, 4.5],
  [52, 3.25], [60, 6], [68, 4.75], [75, 1.5], [82, 2.75], [87, 21.5], [95, 19],
  [103, 24.25], [110, 22], [118, 28.5], [126, 26], [134, 33.75], [142, 2.5],
  [150, 5], [158, 1.75], [166, 8.25], [174, 12.5], [182, 10], [190, 17.75],
  [198, 21], [205, 24.5], [212, 27.7],
];

export const TOP_HANDS = {
  win: {
    hand: 87, cards: ['K♠', 'Q♠'], board: ['Q♦', '7♠', '2♠', '9♣', 'A♠'],
    opponent: 'Theo: J♠, T♦', invested: 18.5, collected: 37.25, net: 18.75,
  },
  loss: {
    hand: 142, cards: ['A♥', 'A♣'], board: ['8♥', '9♥', 'T♣', 'J♦', '2♠'],
    opponent: 'Jun: Q♣, 7♥', invested: 31.25, collected: 0, net: -31.25,
  },
};

// Ledger nets in dollars. They sum to zero.
export const LEDGER = [
  { name: 'Jun', net: 86.4 },
  { name: 'Priya', net: 41.15 },
  { name: 'You', net: 27.7 },
  { name: 'Marisol', net: -12.25 },
  { name: 'Theo', net: -63.8 },
  { name: 'Lena', net: -79.2 },
];

// Same greedy matching as settleDebts in Ledger.jsx.
export function settle(ledger) {
  const creditors = ledger.filter(p => p.net > 0).map(p => ({ ...p })).sort((a, b) => b.net - a.net);
  const debtors = ledger.filter(p => p.net < 0).map(p => ({ ...p })).sort((a, b) => a.net - b.net);
  const transfers = [];
  let i = 0;
  let j = 0;
  while (i < debtors.length && j < creditors.length) {
    const amount = Math.min(creditors[j].net, -debtors[i].net);
    transfers.push({ from: debtors[i].name, to: creditors[j].name, amount: Math.round(amount * 100) / 100 });
    debtors[i].net += amount;
    creditors[j].net -= amount;
    if (Math.abs(debtors[i].net) < 0.01) i++;
    if (Math.abs(creditors[j].net) < 0.01) j++;
  }
  return transfers;
}

export const TRANSFERS = settle(LEDGER);

// Bankroll: twelve weekly sessions, profit in dollars.
export const BANKROLL = [12.5, -8.25, 31.0, 4.75, -22.5, 18.25, 9.0, -4.5, 27.7, 15.25, -11.0, 23.5];

export const formatMoney = (n, { sign = false } = {}) => {
  const abs = Math.abs(n).toFixed(2);
  if (n < 0) return `-$${abs}`;
  return `${sign ? '+' : ''}$${abs}`;
};
